import { FaGift } from "react-icons/fa6";

interface IProps {
  alt: string;
  src?: string | null;
  size?: number;
}

export function RewardThumb({ alt, src, size = 72 }: IProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        style={{
          width: size,
          height: size,
          borderRadius: 8,
          objectFit: "cover",
          border: "1px solid #e5e7eb",
        }}
      />
    );
  }

  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light text-muted"
      title={alt}
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        border: "1px solid #e5e7eb",
      }}
    >
      <FaGift />
    </div>
  );
}
